import React from 'react';

interface IconPhoneProps {
    iconClasses?: string;
}

const IconPhone: React.FC<IconPhoneProps> = ({ iconClasses }) => {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`icon icon-phone ${iconClasses ?? ''}`}
            aria-hidden="true"
        >
            <path
                d="M12.1873 9.28672V11.0367C12.188 11.1992 12.1547 11.36 12.0896 11.5088C12.0246 11.6577 11.9291 11.7913 11.8094 11.9011C11.6897 12.011 11.5483 12.0946 11.3944 12.1466C11.2405 12.1987 11.0775 12.218 10.9157 12.2034C9.12066 12.0083 7.39642 11.395 5.88151 10.4126C4.47207 9.51694 3.27712 8.32199 2.38151 6.91255C1.39566 5.39075 0.782147 3.65813 0.590672 1.85505C0.576095 1.69374 0.595266 1.53116 0.646964 1.37767C0.698662 1.22417 0.781755 1.08312 0.890952 0.963497C1.00015 0.843874 1.13306 0.748299 1.28122 0.682856C1.42938 0.617413 1.58954 0.583537 1.75151 0.583385H3.50151C3.7846 0.580599 4.05905 0.680847 4.2737 0.865446C4.48835 1.05004 4.62855 1.3064 4.66817 1.58672C4.74226 2.14672 4.87876 2.6968 5.07651 3.22588C5.15499 3.43467 5.17198 3.66158 5.12545 3.87973C5.07893 4.09788 4.97084 4.29812 4.81401 4.45672L4.07317 5.19755C4.90358 6.65795 6.11277 7.86714 7.57317 8.69755L8.31401 7.95672C8.47261 7.79988 8.67284 7.6918 8.89099 7.64527C9.10914 7.59875 9.33605 7.61573 9.54484 7.69422C10.0739 7.89197 10.624 8.02847 11.184 8.10255C11.4674 8.14253 11.7262 8.28525 11.9111 8.50359C12.0961 8.72193 12.1944 9.00064 12.1873 9.28672Z"
                stroke="currentColor"
                strokeWidth="1.16667"
            />
        </svg>
    );
};

export default IconPhone;
